import type { FormEventHandler } from "react";

import { trpc } from "@blis/trpc/react";

import { Button } from "@/components/ui/button";
import {
  Dialog,
  DialogBody,
  DialogCloseButton,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";
import { Label, TextArea, TextField } from "@/components/ui/field";
import { Form } from "@/components/ui/form";
import { Modal } from "@/components/ui/modal";
import { toast } from "@/components/ui/toast";
import { useDialogProps } from "../detail/state";

type CancelDialogProps = {
  accession: { id: number };
};

export function CancelDialog(props: CancelDialogProps) {
  const dialogProps = useDialogProps("cancel");
  const cancel = trpc.accession.cancel.useMutation({
    onSuccess() {
      toast.success("Accession cancelled");
      dialogProps.onOpenChange?.(false);
    },
    onError(err) {
      toast.error("Error cancelling accession", {
        description: err.message,
      });
    },
  });

  const save: FormEventHandler<HTMLFormElement> = async (e) => {
    e.preventDefault();
    const values = Object.fromEntries(new FormData(e.currentTarget));
    cancel.mutate({
      id: props.accession.id,
      reason: values.reason as string,
    });
  };

  return (
    <Modal isOpen={dialogProps.open} onOpenChange={dialogProps.onOpenChange}>
      <Dialog>
        <DialogHeader>
          <DialogTitle>Cancel accession</DialogTitle>
        </DialogHeader>
        <DialogBody>
          <Form onSubmit={save} id="cancel-form">
            <TextField name="reason" isRequired>
              <Label>Reason for cancelling</Label>
              <TextArea />
            </TextField>
          </Form>
        </DialogBody>
        <DialogFooter>
          <Button
            type="submit"
            form="cancel-form"
            isPending={cancel.isPending}
            isDisabled={cancel.isPending}
          >
            Submit
          </Button>
          <DialogCloseButton>Cancel</DialogCloseButton>
        </DialogFooter>
      </Dialog>
    </Modal>
  );
}
